var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyRatingSmallStar = function SvgEmptyRatingSmallStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DCE9",
    d: "M13.17 15.75a.75.75 0 0 1-.345-.083L9 13.664l-3.825 2.003a.75.75 0 0 1-1.087-.795l.75-4.223-3.09-3a.75.75 0 0 1-.188-.75.75.75 0 0 1 .608-.51l4.275-.622 1.882-3.848a.75.75 0 0 1 1.35 0l1.905 3.84 4.275.623a.75.75 0 0 1 .608.51.75.75 0 0 1-.188.75l-3.09 3 .75 4.222a.75.75 0 0 1-.3.75.75.75 0 0 1-.465.135Z"
  })));
};
export default SvgEmptyRatingSmallStar;